import { getContainerTypes } from "../productCommons/index.js";

export const isIneligibleForFulfillmentType = ({
  fulfillmentType,
  item,
}: {
  fulfillmentType?: {
    fulfillmentType:
      | "direct"
      | "collection"
      | "courier"
      | "haulier"
      | "sellarDistribution"
      | null;
    ContainerTypeEligibilityRules: {
      id: number;
      containerType: "plasticKeg" | "steelKeg" | "cask";
      volume: number;
      unit: "L" | "gal";
    }[];
  };
  item: {
    containerType: string | null;
    unit: string | null;
    volume: number | null;
  };
}) => {
  if (!fulfillmentType || fulfillmentType.fulfillmentType !== "courier") {
    return false;
  }

  const containerType = getContainerTypes(item.containerType);
  if (
    !containerType.includes("cask") &&
    !containerType.includes("plasticKeg") &&
    !containerType.includes("steelKeg")
  ) {
    return false;
  }

  let shouldSwitch = false;

  const rulesByContainerType = Object.fromEntries(
    fulfillmentType.ContainerTypeEligibilityRules.map((rule) => [
      rule.containerType,
      rule,
    ]),
  );

  let rule = rulesByContainerType["cask"];
  if (containerType.includes("plasticKeg"))
    rule = rulesByContainerType["plasticKeg"];
  if (containerType.includes("steelKeg"))
    rule = rulesByContainerType["steelKeg"];

  if (!rule) return true;

  if (
    rule &&
    item.volume &&
    item.unit &&
    item.volume > rule.volume &&
    item.unit === rule.unit
  ) {
    shouldSwitch = true;
  }

  return shouldSwitch;
};
